import { createApi } from '@reduxjs/toolkit/query/react';
import { urls } from '../../utils/helpers/ApiClient';
import axiosFetchBase from '../axiosFetchBase';

export const slidersApi = createApi({
  reducerPath: 'slidersApi',
  keepUnusedDataFor: 0,
  baseQuery: axiosFetchBase,
  endpoints: (builder) => ({
    getSlidersWithEdit: builder.query({
      query() {
        return {
          url: urls.slidersEdit,
          method: 'GET',
        };
      },
    }),
    getSliders: builder.query({
      query() {
        return {
          url: urls.sliders,
          method: 'GET',
        };
      },
    }),
    getSlider: builder.query({
      query: (id) => ({
        url: urls.sliderDetail(id),
        method: 'GET',
      }),
    }),
    deleteSlider: builder.mutation({
      query(id) {
        return {
          url: urls.sliderDetail(id),
          method: 'DELETE',
        };
      },
    }),
    saveSlider: builder.mutation({
      query(req) {
        const dataObject = {
          target_url: req.body.target_url,
          image: req.body.image,
          image_object:
            req.body.image_object !== undefined ? req.body.image_object : [],
          meta_name: req.body.meta_name,
          active: Number(req.body.active),
        };

        let packedData = new FormData(); // because of file

        Object.keys(dataObject).forEach((key) =>
          packedData.append(key, dataObject[key]),
        );

        if (req.id) {
          packedData.append('_method', 'put');
          return {
            url: urls.sliderDetail(req.id),
            method: 'POST',
            data: packedData,
          };
        } else {
          return {
            url: urls.sliders,
            method: 'POST',
            data: packedData,
          };
        }
      },
    }),
    saveSlidersOrder: builder.mutation({
      query(slidersData) {
        return {
          url: urls.sliderOrder,
          method: 'POST',
          data: { items: slidersData },
        };
      },
    }),
  }),
});

export const {
  useGetSlidersWithEditQuery,
  useGetSlidersQuery,
  useGetSliderQuery,
  useDeleteSliderMutation,
  useSaveSliderMutation,
  useSaveSlidersOrderMutation,
} = slidersApi;
